import { insertReusableContent, openCustomBlocksMenu } from './operations';

const slashMenu = {
  'Reuse Content': { icon: 'reuse-content', shortcut: '<', transform: openCustomBlocksMenu },
  'New Content': { icon: 'plus-square', transform: insertReusableContent },
};

export default slashMenu;
